import type { Ref } from 'vue';
import { computed, ref } from 'vue';
/** 多个数据加载状态 */
export default function useDataLoading() {
  const loadingData = ref<Set<string | number>>(new Set());

  function isLoading(data?: string | number | null): Ref<boolean> {
    if (data === undefined || data === null) {
      return computed(() => loadingData.value.size > 0);
    }
    return computed(() => loadingData.value.has(data));
  }

  function setLoading(data: string | number | string[] | number[], loading: boolean) {
    if (loading) {
      if (Array.isArray(data)) {
        data.forEach(item => {
          loadingData.value.add(item);
        });
      } else {
        loadingData.value.add(data);
      }
    } else if (Array.isArray(data)) {
      data.forEach(item => {
        loadingData.value.delete(item);
      });
    } else {
      loadingData.value.delete(data);
    }
  }

  return {
    isLoading,
    setLoading
  };
}
